import { withEntitiesStore } from '@bodyanalytics/ui-core';
import { signalStore } from '@ngrx/signals';
import { HomeService } from './home.service';

export const HomesStore = signalStore(withEntitiesStore('home', HomeService));
